import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, Transition as _Transition, Fragment as _Fragment } from "vue";
import _imports_0 from '@/assets/addCurrentAccountBenefits.png';
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "money-page" };
const _hoisted_3 = {
    key: 0,
    class: "video-carousel-section"
};
const _hoisted_4 = {
    key: 1,
    class: "video-carousel-section"
};
const _hoisted_5 = { class: "content-section" };
const _hoisted_6 = {
    key: 0,
    class: "how-it-works-button"
};
const _hoisted_7 = {
    key: 1,
    class: "how-it-works-button"
};
const _hoisted_8 = { class: "full-width-section" };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = { class: "full-width-section" };
const _hoisted_11 = {
    key: 3,
    class: "account-type-grid-section"
};
const _hoisted_12 = { class: "drawer-tx-wrap" };
const _hoisted_13 = { class: "drawer-account-type-grid-wrapper" };
const _hoisted_14 = { key: 0 };
const _hoisted_15 = ["src"];
const _hoisted_16 = {
    key: 1,
    class: "offline-account-list"
};
const _hoisted_17 = ["src"];
const _hoisted_18 = {
    key: 2,
    class: "specific-account-content"
};
const _hoisted_19 = { class: "connect-buttons-wrapper" };
import { ref, computed, watch, onMounted, onBeforeUnmount, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useBanking, pendingBankingRevalidate } from '@/composables/useBanking';
import { inflightCategoryUpdate } from '@/components/elements/transactionUpdateState';
import { useTransactionUpdateHandoff } from '@/composables/useTransactionUpdateHandoff';
import { useInsurance } from '@/composables/useInsurance';
import { useMortgage, pendingMortgageRevalidate } from '@/composables/useMortgage';
import { useInvestments, pendingInvestmentRevalidate } from '@/composables/useInvestments';
import { useCredit, pendingCreditRevalidate } from '@/composables/useCredit';
import { useContent } from '@/composables/useContent';
import { useVouchers } from '@/composables/useVouchers';
import { useTransactions } from '@/composables/useTransactions';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
import AccountTypeGrid from './elements/AccountTypeGrid.vue';
import WalkthroughDrawerPanel from './elements/WalkthroughDrawerPanel.vue';
import SimpleDrawerPanel from './elements/SimpleDrawerPanel.vue';
import AiChatBanner from './elements/AiChatBanner.vue';
import AiChatCard from './elements/AiChatCard.vue';
import FaqsSection from './FaqsSection.vue';
import MGWalkthrough from './elements/MGWalkthrough.vue';
import AccountTypeFilter from './elements/AccountTypeFilter.vue';
import AccountCardsSection from './elements/AccountCardsSection.vue';
import AwaitBankAccountPanel from './elements/AwaitBankAccountPanel.vue';
import RecentTransactionsSection from './elements/RecentTransactionsSection.vue';
import TransactionsList from './elements/TransactionsList.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MoneyPage',
    setup(__props) {
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getBankingInfo, getOpenBankingLinkUrl } = useBanking();
        const { updatingTransactionId, takePending, } = useTransactionUpdateHandoff();
        const { getInsuranceInfo } = useInsurance();
        const { getMortgageInfo } = useMortgage();
        const { getInvestmentInfo } = useInvestments();
        const { getCreditInfo } = useCredit();
        const { getWalkthrough, getFaqs, getSuggestedAssets } = useContent();
        const { getAvailableVouchers, attachAvailableVouchers } = useVouchers();
        const { searchTransactions } = useTransactions();
        // Template refs
        const walkthroughDrawer = ref(null);
        // Drawer open state
        const transactionsDrawerOpen = ref(false);
        const scrollToTxId = ref(null);
        // Data
        const currentSlide = ref(0);
        const walkthroughData = ref(null);
        const slideKey = ref(null);
        const heroWalkthroughData = ref(null);
        const heroCarouselReady = ref(false);
        const currentAccounts = ref([]);
        const currentAccountsBalance = ref(0);
        const creditAccounts = ref([]);
        const creditAccountsBalance = ref(0);
        const savingAccounts = ref([]);
        const savingAccountsBalance = ref(0);
        const selectedSection = ref('all');
        const selectedSubSection = ref('all');
        const adding = ref(false);
        const bankInfoLoaded = ref(false);
        const insuranceInfoLoaded = ref(false);
        const mortgageInfoLoaded = ref(false);
        const investmentInfoLoaded = ref(false);
        const creditInfoLoaded = ref(false);
        const drawerTitle = ref('Add account');
        const isSpecificAccountMode = ref(false);
        const isOfflineMode = ref(false);
        const prevDrawerTitle = ref('');
        const drawerFilter = ref(null);
        const faqs = ref([]);
        const suggestedAssets = ref(null);
        const drawerOpen = ref(false);
        const loadingWalkthrough = ref(false);
        const relinkNeeded = ref(false);
        const transactions = ref(null);
        // Computed
        const navigationTabs = computed(() => {
            const tabs = [{ value: 'all', label: 'All' }];
            const d2dTab = { value: 'd2d', label: 'Day-to-day' };
            if (hasBankAccounts.value || hasSuggestedSection('Day-to-day')) {
                const d2dSubs = [
                    { value: 'current', label: 'Current', hasData: currentAccounts.value?.length > 0 || hasSuggestedSection('Day-to-day > Current') },
                    { value: 'credit', label: 'Credit', hasData: creditAccounts.value?.length > 0 || hasSuggestedSection('Day-to-day > Credit') },
                    { value: 'savings', label: 'Savings', hasData: savingAccounts.value?.length > 0 || hasSuggestedSection('Day-to-day > Savings') }
                ];
                d2dSubs.sort((a, b) => (b.hasData ? 1 : 0) - (a.hasData ? 1 : 0));
                d2dTab.subTabs = [{ value: 'all', label: 'All' }, ...d2dSubs];
            }
            tabs.push(d2dTab);
            const ltTab = { value: 'lt', label: 'Long-term' };
            const hasLongTermAccounts = (state.mortgageInfo?.length ?? 0) > 0 ||
                (state.creditInfo?.length ?? 0) > 0 ||
                (state.investmentInfo?.length ?? 0) > 0 ||
                hasSuggestedSection('Long-term');
            if (hasLongTermAccounts) {
                const ltSubs = [
                    { value: 'mortgages', label: 'Mortgages', hasData: (state.mortgageInfo?.length ?? 0) > 0 || hasSuggestedSection('Long-term > Mortgages') },
                    { value: 'loans', label: 'Loans', hasData: (state.creditInfo?.length ?? 0) > 0 || hasSuggestedSection('Long-term > Loans') },
                    { value: 'pensions', label: 'Pensions', hasData: state.investmentInfo?.some((a) => a.accountType?.name === 'Pension') || hasSuggestedSection('Long-term > Pensions') },
                    { value: 'investments', label: 'Investments', hasData: state.investmentInfo?.some((a) => a.accountType?.name === 'Investment') || hasSuggestedSection('Long-term > Investments') }
                ];
                ltSubs.sort((a, b) => (b.hasData ? 1 : 0) - (a.hasData ? 1 : 0));
                ltTab.subTabs = [{ value: 'all', label: 'All' }, ...ltSubs];
            }
            tabs.push(ltTab);
            tabs.push({ value: 'ins', label: 'Insurance' });
            return tabs;
        });
        const showCurrentCard = computed(() => {
            if (selectedSection.value === 'all')
                return true;
            if (selectedSection.value === 'd2d') {
                return selectedSubSection.value === 'all' || selectedSubSection.value === 'current';
            }
            return false;
        });
        const showCreditCard = computed(() => {
            if (selectedSection.value === 'all')
                return true;
            if (selectedSection.value === 'd2d') {
                return selectedSubSection.value === 'all' || selectedSubSection.value === 'credit';
            }
            return false;
        });
        const showSavingCard = computed(() => {
            if (selectedSection.value === 'all')
                return true;
            if (selectedSection.value === 'd2d') {
                return selectedSubSection.value === 'all' || selectedSubSection.value === 'savings';
            }
            return false;
        });
        const showMortgageCard = computed(() => {
            if (selectedSection.value === 'all')
                return true;
            if (selectedSection.value === 'lt') {
                return selectedSubSection.value === 'all' || selectedSubSection.value === 'mortgages';
            }
            return false;
        });
        const showPensionCard = computed(() => {
            if (selectedSection.value === 'all')
                return true;
            if (selectedSection.value === 'lt') {
                return selectedSubSection.value === 'all' || selectedSubSection.value === 'pensions';
            }
            return false;
        });
        const showInvestmentCard = computed(() => {
            if (selectedSection.value === 'all')
                return true;
            if (selectedSection.value === 'lt') {
                return selectedSubSection.value === 'all' || selectedSubSection.value === 'investments';
            }
            return false;
        });
        const showCreditInfo = computed(() => {
            if (selectedSection.value === 'all')
                return true;
            if (selectedSection.value === 'lt') {
                return selectedSubSection.value === 'all' || selectedSubSection.value === 'loans';
            }
            return false;
        });
        const showInsuranceCard = computed(() => {
            return selectedSection.value === 'all' || selectedSection.value === 'ins';
        });
        const hasBankAccounts = computed(() => {
            return currentAccounts.value.length > 0 ||
                creditAccounts.value.length > 0 ||
                savingAccounts.value.length > 0;
        });
        const hasAnyAccounts = computed(() => {
            return currentAccounts.value?.length > 0 ||
                creditAccounts.value?.length > 0 ||
                savingAccounts.value?.length > 0 ||
                (state.mortgageInfo?.length ?? 0) > 0 ||
                (state.insuranceInfo?.length ?? 0) > 0 ||
                (state.investmentInfo?.length ?? 0) > 0 ||
                (state.creditInfo?.length ?? 0) > 0 ||
                (suggestedAssets.value?.length ?? 0) > 0;
        });
        const allAccountsLoaded = computed(() => {
            return bankInfoLoaded.value && insuranceInfoLoaded.value && mortgageInfoLoaded.value && investmentInfoLoaded.value && creditInfoLoaded.value;
        });
        const openHeight = computed(() => {
            if (isSpecificAccountMode.value || isOfflineMode.value) {
                return '95%';
            }
            if (drawerFilter.value === 'd2d') {
                return '480px';
            }
            if (drawerFilter.value === 'lt') {
                return '560px';
            }
            return '95%';
        });
        const filteredTransactions = computed(() => {
            if (!transactions.value || selectedSection.value !== 'd2d' || selectedSubSection.value === 'all') {
                return transactions.value;
            }
            const accountIds = getAccountIdsByType(selectedSubSection.value);
            if (!accountIds || accountIds.length === 0) {
                return [];
            }
            return transactions.value.map((group) => {
                return group.filter((t) => accountIds.includes(t.bankAccountID));
            }).filter((group) => group.length > 0);
        });
        const getRecentTransactionsAccountType = computed(() => {
            if (selectedSection.value === 'all' || selectedSubSection.value === 'all') {
                return 'all';
            }
            return selectedSubSection.value;
        });
        const filteredCreditInfo = computed(() => {
            if (!state.creditInfo)
                return [];
            if (!state.mortgageInfo || state.mortgageInfo.length === 0)
                return state.creditInfo;
            const mortgageAccountIds = state.mortgageInfo
                .map((m) => m.account?.id)
                .filter((id) => id);
            return state.creditInfo.filter((c) => !mortgageAccountIds.includes(c.id));
        });
        // Watchers
        watch(selectedSection, (newVal) => {
            if (newVal === 'all') {
                selectedSubSection.value = 'all';
            }
            localStorage.setItem('money-filter-section', newVal);
        });
        watch(selectedSubSection, (newVal) => {
            localStorage.setItem('money-filter-subsection', newVal);
        });
        watch(transactionsDrawerOpen, (open) => {
            if (!open) {
                transactions.value = state.bankInfo?.recentTransactions ?? [];
            }
        });
        // SimpleDrawerPanel has no `@closed` event — mirror DrawerPanel's old behaviour
        // by running the reset on the open→closed transition.
        watch(drawerOpen, (open, wasOpen) => {
            if (wasOpen && !open)
                handleDrawerClosed();
        });
        // Methods
        function hasSuggestedSection(prefix) {
            if (!suggestedAssets.value)
                return false;
            return suggestedAssets.value.some((a) => {
                const s = a.uiElement?.section || '';
                return s === prefix || s.startsWith(prefix + ' >');
            });
        }
        function getAccountIdsByType(type) {
            if (!state.bankInfo || !state.bankInfo.accounts) {
                return [];
            }
            if (type === 'all') {
                return state.bankInfo.accounts.map((a) => a.id);
            }
            const accountTypeMap = {
                'current': 'Current',
                'credit': 'Credit',
                'savings': 'Savings'
            };
            const prettyName = accountTypeMap[type];
            if (!prettyName) {
                return [];
            }
            return state.bankInfo.accounts
                .filter((a) => a.accountType?.prettyName === prettyName)
                .map((a) => a.id);
        }
        function onLoad(bankInfoCallback) {
            getCustomer(() => {
                getBankInfoLocal((isStale) => {
                    bankInfoLoaded.value = true;
                    bankInfoCallback?.(isStale);
                });
                getInsuranceInfo(() => {
                    insuranceInfoLoaded.value = true;
                });
                getMortgageInfoLocal(() => {
                    mortgageInfoLoaded.value = true;
                });
                getInvestmentInfoLocal(() => {
                    investmentInfoLoaded.value = true;
                });
                getCreditInfoLocal(() => {
                    creditInfoLoaded.value = true;
                });
            });
            getWalkthrough('money-hero', (result) => {
                heroWalkthroughData.value = result;
            });
            getFaqs('money-faqs', (result) => {
                faqs.value = result?.faqItems || [];
            });
            getSuggestedAssets((result) => {
                suggestedAssets.value = result.filter((a) => a.relatedDocuments?.length > 0) || null;
            });
        }
        function getBankInfoLocal(onSuccess = null) {
            // If a write just happened elsewhere (e.g. TransactionDetailPage), SWR+poll
            // until the banking-info payload reflects the change.
            // Also revalidate-and-poll when a TDP category update is still in flight,
            // even if the one-shot pendingBankingRevalidate flag has already been
            // consumed by an earlier mount of this page.
            const revalidate = pendingBankingRevalidate.value || !!inflightCategoryUpdate.value;
            pendingBankingRevalidate.value = false;
            getBankingInfo((isStale) => {
                currentAccounts.value = [];
                currentAccountsBalance.value = 0;
                creditAccounts.value = [];
                creditAccountsBalance.value = 0;
                savingAccounts.value = [];
                savingAccountsBalance.value = 0;
                state.bankInfo.accounts.forEach((a) => {
                    if (a.consentExpired) {
                        relinkNeeded.value = true;
                    }
                    if (a.accountType.prettyName == "Current") {
                        currentAccounts.value.push(a);
                        currentAccountsBalance.value += a.balance;
                    }
                    else if (a.accountType.prettyName == "Credit") {
                        creditAccounts.value.push(a);
                        creditAccountsBalance.value += a.balance;
                    }
                    else if (a.accountType.prettyName == "Savings") {
                        savingAccounts.value.push(a);
                        savingAccountsBalance.value += a.balance;
                    }
                });
                transactions.value = state.bankInfo.recentTransactions;
                loadVouchersForTransactions();
                if (onSuccess) {
                    onSuccess(isStale);
                }
            }, false, null, /* staleWhileRevalidate */ revalidate, /* pollUntilChanged */ revalidate);
        }
        function getMortgageInfoLocal(onSuccess = null) {
            // If a mortgage was just added/updated/deleted (AddMortgagePage/MortgagePage),
            // SWR+poll until the /CreditAccounts/Mortgages payload reflects the write —
            // the cached endpoint lags the write.
            const revalidate = pendingMortgageRevalidate.value;
            pendingMortgageRevalidate.value = false;
            getMortgageInfo((isStale) => {
                if (onSuccess)
                    onSuccess(isStale);
            }, false, /* staleWhileRevalidate */ revalidate, /* pollUntilChanged */ revalidate);
        }
        function getCreditInfoLocal(onSuccess = null) {
            // If a credit account was just added/updated/deleted (AddCreditPage/CreditPage),
            // SWR+poll until the /CreditAccounts payload reflects the write —
            // the cached endpoint lags the write.
            const revalidate = pendingCreditRevalidate.value;
            pendingCreditRevalidate.value = false;
            getCreditInfo((isStale) => {
                if (onSuccess)
                    onSuccess(isStale);
            }, false, /* staleWhileRevalidate */ revalidate, /* pollUntilChanged */ revalidate);
        }
        function getInvestmentInfoLocal(onSuccess = null) {
            // If a pension/investment was just added (AddPensionPage/AddInvestmentPage),
            // SWR+poll until the /InvestmentHubAccounts payload reflects the new account
            // — the cached endpoint lags the write.
            const revalidate = pendingInvestmentRevalidate.value;
            pendingInvestmentRevalidate.value = false;
            getInvestmentInfo((isStale) => {
                if (onSuccess)
                    onSuccess(isStale);
            }, false, false, /* staleWhileRevalidate */ revalidate, /* pollUntilChanged */ revalidate);
        }
        function loadVouchersForTransactions() {
            if (!transactions.value)
                return;
            getAvailableVouchers(() => {
                attachAvailableVouchers(transactions.value);
                transactions.value = [...transactions.value];
            });
        }
        function showWalkthrough() {
            const noBankAccounts = currentAccounts.value.length == 0 && creditAccounts.value.length == 0 && savingAccounts.value.length == 0;
            return noBankAccounts && (!hasAnyAccounts.value || selectedSection.value === 'all');
        }
        function handleHeroSlideChange(index) {
            currentSlide.value = index;
        }
        function handleLinkAccount() {
            drawerOpen.value = false;
            document.body.classList.remove('hide-nav-bar');
            adding.value = true;
            var navTo = getOpenBankingLinkUrl(state.customer.id);
            window.open(navTo, '_blank');
        }
        function handleLinkOfflineAccount() {
            isOfflineMode.value = true;
            prevDrawerTitle.value = drawerTitle.value;
            drawerTitle.value = 'Add Offline Account';
        }
        function handleOfflineBack() {
            isOfflineMode.value = false;
            drawerTitle.value = prevDrawerTitle.value || 'Add Account';
        }
        function handleAddDifferentAccount() {
            isSpecificAccountMode.value = false;
        }
        function handleHowItWorks() {
            router.push('/story/money-how-it-works');
        }
        function handleStartWalkthroughClick(accountType) {
            if (loadingWalkthrough.value)
                return;
            loadingWalkthrough.value = true;
            getWalkthrough(accountType.walkthrough, (result) => {
                loadingWalkthrough.value = false;
                slideKey.value = accountType.key;
                walkthroughData.value = result;
                drawerOpen.value = false;
                nextTick(() => {
                    if (walkthroughDrawer.value) {
                        walkthroughDrawer.value.openDrawer();
                    }
                });
            });
        }
        function handleAddAccountClick(section = null) {
            const d2dSubSectionLabels = {
                'current': 'current',
                'credit': 'credit card',
                'savings': 'savings'
            };
            if (section && d2dSubSectionLabels[section]) {
                drawerTitle.value = `Add a ${d2dSubSectionLabels[section]} account`;
                isSpecificAccountMode.value = true;
                drawerOpen.value = true;
                return;
            }
            const ltSubSectionKeys = {
                'mortgages': 'mortgage',
                'loans': 'loans',
                'pensions': 'pension',
                'investments': 'investments'
            };
            if (section && ltSubSectionKeys[section]) {
                const key = ltSubSectionKeys[section];
                const accountType = { walkthrough: 'money-account-types', key };
                handleStartWalkthroughClick(accountType);
                return;
            }
            drawerFilter.value = section;
            if (section === 'lt') {
                drawerTitle.value = 'Add a long-term account';
            }
            else if (section === 'd2d') {
                drawerTitle.value = 'Add a day-to-day account';
            }
            else {
                drawerTitle.value = 'Add account';
            }
            drawerOpen.value = true;
        }
        function handleActionClicked(actionUri) {
            if (actionUri === '*truelayer*') {
                if (walkthroughDrawer.value) {
                    walkthroughDrawer.value.closeDrawer();
                }
                drawerTitle.value = `Add a ${slideKey.value || ''} account`;
                isSpecificAccountMode.value = true;
                drawerOpen.value = true;
                return;
            }
            if (actionUri) {
                setTimeout(() => {
                    router.push(actionUri);
                }, 300);
            }
        }
        function handleSuggestedAssetClick(asset) {
            router.push('/Policies/suggested?assetId=' + asset.id);
        }
        function handleMortgageClick() {
            router.push('/money');
        }
        function goToTransaction(t) {
            if (!t?.id)
                return;
            router.push('/TransactionDetail/' + t.id);
        }
        function onDrawerTransactionClick(t) {
            if (!t?.id)
                return;
            sessionStorage.setItem('reopenMoneyTransactionsDrawer', 'true');
            sessionStorage.setItem('reopenMoneyTransactionsScrollId', t.id);
            goToTransaction(t);
        }
        function handleFilterChanged(filterObj) {
            if (filterObj.subSection !== undefined) {
                selectedSection.value = filterObj.section;
                nextTick(() => {
                    selectedSubSection.value = filterObj.subSection;
                });
            }
            else {
                selectedSection.value = filterObj.section;
            }
            window.scrollTo(0, 0);
        }
        function handleAltAction(accountType) {
            const accountTypeName = accountType.label.replace(' Account', '').replace(' Card', '').replace(' Policy', '').toLowerCase();
            drawerTitle.value = `Add a ${accountTypeName} account`;
            isSpecificAccountMode.value = true;
        }
        function handleDrawerClosed() {
            drawerTitle.value = 'Add account';
            isSpecificAccountMode.value = false;
            isOfflineMode.value = false;
            drawerFilter.value = null;
            drawerOpen.value = false;
            document.body.classList.remove('hide-nav-bar');
        }
        function handleViewAllAccounts() {
            drawerFilter.value = null;
            drawerTitle.value = 'Add account';
        }
        function determineCarouselHeight() {
            if (window.innerHeight < 700) {
                return '150px';
            }
            else {
                return '240px';
            }
        }
        function openTransactionsDrawer() {
            transactionsDrawerOpen.value = true;
        }
        function searchBackTransactions(query) {
            searchTransactions(query, (result) => {
                // Merge server results with the existing window. Server search only
                // matches merchant names, so a query like "Bills" returns merchants
                // literally named "Bills" — replacing outright would lose any txns
                // the local filter had matched by category/sub-classification name.
                // Dedupe by id and regroup by day so the date headers stay correct.
                const seen = new Set();
                const byDay = new Map();
                const ingest = (groups) => {
                    for (const g of groups ?? []) {
                        for (const t of g ?? []) {
                            if (!t?.id || seen.has(t.id))
                                continue;
                            seen.add(t.id);
                            const key = t.timestampString ?? '';
                            const arr = byDay.get(key) ?? [];
                            arr.push(t);
                            byDay.set(key, arr);
                        }
                    }
                };
                ingest(transactions.value);
                ingest(result);
                // Newest day first — use the first tx's timestamp as the group key.
                const merged = [...byDay.values()].sort((a, b) => (b[0]?.timestamp ?? 0) - (a[0]?.timestamp ?? 0));
                transactions.value = merged;
            });
        }
        function resetFilters() {
            selectedSection.value = 'all';
            selectedSubSection.value = 'all';
        }
        onMounted(() => {
            document.body.classList.remove('hide-nav-bar');
            // Restore filter selection from localStorage
            const savedSection = localStorage.getItem('money-filter-section');
            const savedSubSection = localStorage.getItem('money-filter-subsection');
            if (savedSection) {
                selectedSection.value = savedSection;
                if (savedSubSection) {
                    selectedSubSection.value = savedSubSection;
                }
            }
            // Read query params from actual URL
            const hashQuery = window.location.hash.split('?')[1];
            const params = hashQuery ? new URLSearchParams(hashQuery) : null;
            // Only act on params if not already consumed in this history entry
            if (params && !window.history.state?.moneyParamsConsumed) {
                window.history.replaceState({ ...window.history.state, moneyParamsConsumed: true }, '');
                if (params.get('filter')) {
                    selectedSection.value = params.get('filter');
                }
                if (params.get('show') === 'true') {
                    setTimeout(() => {
                        transactionsDrawerOpen.value = true;
                    }, 500);
                }
                if (params.get('add') === 'true') {
                    isSpecificAccountMode.value = true;
                    drawerOpen.value = true;
                }
            }
            if (sessionStorage.getItem('reopenMoneyTransactionsDrawer') === 'true') {
                sessionStorage.removeItem('reopenMoneyTransactionsDrawer');
                transactionsDrawerOpen.value = true;
                scrollToTxId.value = sessionStorage.getItem('reopenMoneyTransactionsScrollId');
                sessionStorage.removeItem('reopenMoneyTransactionsScrollId');
            }
            // Listen for reset event from MenuBar
            window.addEventListener('reset-money-filters', resetFilters);
            takePending();
            onLoad((isStale) => {
                // Fresh bank-info has landed (after any SWR+poll triggered by
                // pendingBankingRevalidate / inflightCategoryUpdate) — the row reflects
                // the new category, so drop the spinner.
                if (!isStale)
                    updatingTransactionId.value = null;
            });
            // Delay hero carousel render to allow proper layout calculation on mobile
            setTimeout(() => {
                heroCarouselReady.value = true;
            }, 50);
        });
        onBeforeUnmount(() => {
            document.body.classList.remove('hide-nav-bar');
            window.removeEventListener('reset-money-filters', resetFilters);
        });
        return (_ctx, _cache) => {
            const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, { title: "Money" }),
                (adding.value && _unref(state).bankInfo)
                    ? (_openBlock(), _createBlock(AwaitBankAccountPanel, {
                        key: 0,
                        origCount: _unref(state).bankInfo.accounts.length,
                        onAccountAdded: _cache[0] || (_cache[0] = ($event) => { adding.value = false; getBankInfoLocal(); })
                    }, null, 8, ["origCount"]))
                    : _createCommentVNode("", true),
                _createVNode(AiChatBanner),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).customer
                }, null, 8, ["customer"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).customer)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                (allAccountsLoaded.value && hasAnyAccounts.value)
                                    ? (_openBlock(), _createBlock(AccountTypeFilter, {
                                        key: 0,
                                        tabs: navigationTabs.value,
                                        modelValue: selectedSection.value,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((selectedSection).value = $event)),
                                        subTabValue: selectedSubSection.value,
                                        "onUpdate:subTabValue": _cache[2] || (_cache[2] = ($event) => ((selectedSubSection).value = $event)),
                                        class: "money-tabs"
                                    }, null, 8, ["tabs", "modelValue", "subTabValue"]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_2, [
                                    (showWalkthrough() && (!heroWalkthroughData.value || !heroCarouselReady.value))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                            _createVNode(_component_v_skeleton_loader, {
                                                type: "card",
                                                height: determineCarouselHeight()
                                            }, null, 8, ["height"])
                                        ]))
                                        : _createCommentVNode("", true),
                                    (bankInfoLoaded.value && heroWalkthroughData.value && showWalkthrough() && heroCarouselReady.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                            _createVNode(MGWalkthrough, {
                                                walkthroughData: heroWalkthroughData.value,
                                                variant: "sheet",
                                                compact: true,
                                                dotsAbove: false,
                                                imageHeight: '220',
                                                height: determineCarouselHeight(),
                                                onActionClicked: handleLinkAccount,
                                                onSlideIndexChanged: handleHeroSlideChange
                                            }, null, 8, ["walkthroughData", "height"])
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_5, [
                                        (!allAccountsLoaded.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                                _createVNode(_component_v_skeleton_loader, {
                                                    type: "button",
                                                    height: "60px"
                                                })
                                            ]))
                                            : _createCommentVNode("", true),
                                        (allAccountsLoaded.value && !hasBankAccounts.value && (!hasAnyAccounts.value || selectedSection.value === 'all'))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                                _createVNode(MGButton, {
                                                    fullWidth: true,
                                                    stacked: true,
                                                    outline: true,
                                                    noCaps: true,
                                                    text: "How it works",
                                                    arrow: true,
                                                    onClick: handleHowItWorks
                                                })
                                            ]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_8, [
                                            (!allAccountsLoaded.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                    _createVNode(_component_v_skeleton_loader, {
                                                        type: "card",
                                                        height: "180px",
                                                        class: "mb-4"
                                                    }),
                                                    _createVNode(_component_v_skeleton_loader, {
                                                        type: "card",
                                                        height: "180px",
                                                        class: "mb-4"
                                                    }),
                                                    _createVNode(_component_v_skeleton_loader, {
                                                        type: "card",
                                                        height: "180px"
                                                    })
                                                ]))
                                                : _createCommentVNode("", true),
                                            (allAccountsLoaded.value)
                                                ? (_openBlock(), _createBlock(AccountCardsSection, {
                                                    key: 1,
                                                    currentAccounts: currentAccounts.value,
                                                    currentAccountsBalance: currentAccountsBalance.value,
                                                    creditAccounts: creditAccounts.value,
                                                    creditAccountsBalance: creditAccountsBalance.value,
                                                    savingAccounts: savingAccounts.value,
                                                    savingAccountsBalance: savingAccountsBalance.value,
                                                    mortgageInfo: _unref(state).mortgageInfo,
                                                    insuranceInfo: _unref(state).insuranceInfo,
                                                    creditInfo: filteredCreditInfo.value,
                                                    investmentInfo: _unref(state).investmentInfo,
                                                    showCreditInfo: showCreditInfo.value,
                                                    showCurrentCard: showCurrentCard.value,
                                                    showCreditCard: showCreditCard.value,
                                                    showMortgageCard: showMortgageCard.value,
                                                    showInsuranceCard: showInsuranceCard.value,
                                                    showSavingCard: showSavingCard.value,
                                                    showPensionCard: showPensionCard.value,
                                                    showInvestmentCard: showInvestmentCard.value,
                                                    formatter: _unref(state).formatter,
                                                    selectedSection: selectedSection.value,
                                                    suggestedAssets: suggestedAssets.value || [],
                                                    selectedSubSection: selectedSubSection.value,
                                                    onFilterChanged: handleFilterChanged,
                                                    onMortgageClick: handleMortgageClick,
                                                    onAddAccountClick: handleAddAccountClick,
                                                    onSuggestedAssetClick: handleSuggestedAssetClick
                                                }, null, 8, ["currentAccounts", "currentAccountsBalance", "creditAccounts", "creditAccountsBalance", "savingAccounts", "savingAccountsBalance", "mortgageInfo", "insuranceInfo", "creditInfo", "investmentInfo", "showCreditInfo", "showCurrentCard", "showCreditCard", "showMortgageCard", "showInsuranceCard", "showSavingCard", "showPensionCard", "showInvestmentCard", "formatter", "selectedSection", "suggestedAssets", "selectedSubSection"]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_10, [
                                            (allAccountsLoaded.value && hasBankAccounts.value && transactions.value && (selectedSection.value === 'all' || selectedSection.value === 'd2d'))
                                                ? (_openBlock(), _createBlock(RecentTransactionsSection, {
                                                    key: 0,
                                                    transactions: transactions.value,
                                                    formatter: _unref(state).formatter,
                                                    today: _unref(state).today,
                                                    yesterday: _unref(state).yesterday,
                                                    accountType: getRecentTransactionsAccountType.value,
                                                    accountIds: getAccountIdsByType(getRecentTransactionsAccountType.value),
                                                    updatingTransactionId: _unref(updatingTransactionId),
                                                    onTransactionClick: goToTransaction,
                                                    categoryPills: true,
                                                    onViewMore: openTransactionsDrawer
                                                }, null, 8, ["transactions", "formatter", "today", "yesterday", "accountType", "accountIds", "updatingTransactionId"]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        (allAccountsLoaded.value)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 2,
                                                onClick: _cache[3] || (_cache[3] = ($event) => (handleAddAccountClick()))
                                            }, _cache[8] || (_cache[8] = [
                                                _createElementVNode("p", { class: "what-can-add-heading" }, "What can I add?", -1),
                                                _createElementVNode("p", { class: "what-can-add-subtext" }, "Link more accounts for more detailed analysis", -1)
                                            ])))
                                            : _createCommentVNode("", true),
                                        (!allAccountsLoaded.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                                _createVNode(_component_v_row, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_col, { cols: "6" }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_v_skeleton_loader, {
                                                                    type: "card",
                                                                    height: "120px"
                                                                })
                                                            ]),
                                                            _: 1
                                                        }),
                                                        _createVNode(_component_v_col, { cols: "6" }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_v_skeleton_loader, {
                                                                    type: "card",
                                                                    height: "120px"
                                                                })
                                                            ]),
                                                            _: 1
                                                        }),
                                                        _createVNode(_component_v_col, { cols: "6" }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_v_skeleton_loader, {
                                                                    type: "card",
                                                                    height: "120px"
                                                                })
                                                            ]),
                                                            _: 1
                                                        }),
                                                        _createVNode(_component_v_col, { cols: "6" }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_v_skeleton_loader, {
                                                                    type: "card",
                                                                    height: "120px"
                                                                })
                                                            ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                    _: 1
                                                })
                                            ]))
                                            : _createCommentVNode("", true),
                                        (allAccountsLoaded.value)
                                            ? (_openBlock(), _createBlock(AccountTypeGrid, {
                                                key: 4,
                                                class: "account-type-grid-section",
                                                showAddButton: true,
                                                onAccountTypeClick: handleStartWalkthroughClick,
                                                onAddAccountClick: handleAddAccountClick,
                                                onAltAction: handleAltAction,
                                                currentAccounts: currentAccounts.value,
                                                creditAccounts: creditAccounts.value,
                                                savingAccounts: savingAccounts.value,
                                                insuranceInfo: _unref(state).insuranceInfo,
                                                mortgageInfo: _unref(state).mortgageInfo,
                                                investmentInfo: _unref(state).investmentInfo,
                                                creditInfo: filteredCreditInfo.value,
                                                suggestedAssets: suggestedAssets.value || []
                                            }, null, 8, ["currentAccounts", "creditAccounts", "savingAccounts", "insuranceInfo", "mortgageInfo", "investmentInfo", "creditInfo", "suggestedAssets"]))
                                            : _createCommentVNode("", true),
                                        _createVNode(AiChatCard, { class: "ai-chat-card-section" }),
                                        _createVNode(FaqsSection, {
                                            class: "faq-section",
                                            faqs: faqs.value,
                                            limit: 5,
                                            faqName: "money-faqs"
                                        }, null, 8, ["faqs"])
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                (walkthroughData.value)
                    ? (_openBlock(), _createBlock(WalkthroughDrawerPanel, {
                        key: 1,
                        ref_key: "walkthroughDrawer",
                        ref: walkthroughDrawer,
                        walkthroughData: walkthroughData.value,
                        onActionClicked: handleActionClicked,
                        slideKey: slideKey.value ?? undefined
                    }, null, 8, ["walkthroughData", "slideKey"]))
                    : _createCommentVNode("", true),
                _createVNode(SimpleDrawerPanel, {
                    modelValue: transactionsDrawerOpen.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((transactionsDrawerOpen).value = $event)),
                    title: "Transactions",
                    height: "95vh",
                    closeButton: true,
                    divider: false
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_12, [
                            (filteredTransactions.value && filteredTransactions.value.length > 0)
                                ? (_openBlock(), _createBlock(TransactionsList, {
                                    key: 0,
                                    onCleared: _cache[4] || (_cache[4] = ($event) => (transactions.value = _unref(state).bankInfo?.recentTransactions ?? [])),
                                    onSearchBack: _cache[5] || (_cache[5] = (query) => { searchBackTransactions(query); }),
                                    allowSearchBack: true,
                                    showDateTotal: false,
                                    search: true,
                                    transactions: filteredTransactions.value,
                                    formatter: _unref(state).formatter,
                                    today: _unref(state).today,
                                    yesterday: _unref(state).yesterday,
                                    dividingLines: true,
                                    updatingTransactionId: _unref(updatingTransactionId),
                                    onTransactionClick: onDrawerTransactionClick,
                                    categoryPills: true,
                                    scrollToId: scrollToTxId.value,
                                    excludedFilter: true
                                }, null, 8, ["transactions", "formatter", "today", "yesterday", "updatingTransactionId", "scrollToId"]))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(SimpleDrawerPanel, {
                    modelValue: drawerOpen.value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((drawerOpen).value = $event)),
                    title: drawerTitle.value,
                    height: openHeight.value
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_13, [
                            (!isSpecificAccountMode.value && drawerOpen.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _createVNode(AccountTypeGrid, {
                                        currentAccounts: currentAccounts.value,
                                        creditAccounts: creditAccounts.value,
                                        savingAccounts: savingAccounts.value,
                                        insuranceInfo: _unref(state).insuranceInfo,
                                        cols: 1,
                                        showAddButton: false,
                                        filter: drawerFilter.value,
                                        onAccountTypeClick: handleStartWalkthroughClick,
                                        onAltAction: handleAltAction
                                    }, null, 8, ["currentAccounts", "creditAccounts", "savingAccounts", "insuranceInfo", "filter"]),
                                    (drawerFilter.value)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: "view-all-link",
                                            onClick: handleViewAllAccounts
                                        }, [
                                            _createElementVNode("img", {
                                                src: require('@/assets/arrow-left.svg'),
                                                class: "view-all-arrow"
                                            }, null, 8, _hoisted_15),
                                            _cache[9] || (_cache[9] = _createElementVNode("span", null, "View all", -1))
                                        ]))
                                        : _createCommentVNode("", true)
                                ]))
                                : (isOfflineMode.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                        _createElementVNode("div", {
                                            class: "view-all-link",
                                            onClick: handleOfflineBack
                                        }, [
                                            _createElementVNode("img", {
                                                src: require('@/assets/arrow-left.svg'),
                                                class: "view-all-arrow"
                                            }, null, 8, _hoisted_17),
                                            _cache[10] || (_cache[10] = _createElementVNode("span", null, "Back", -1))
                                        ]),
                                        _createVNode(AccountTypeGrid, {
                                            cols: 1,
                                            showAddButton: false,
                                            offline: true
                                        })
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                        _cache[11] || (_cache[11] = _createElementVNode("p", { class: "specific-account-text" }, "You can bring your current, credit & savings accounts into Money Guided in two secure ways:", -1)),
                                        _cache[12] || (_cache[12] = _createElementVNode("img", {
                                            src: _imports_0,
                                            alt: "Add Current Account Benefits",
                                            class: "account-benefits-image"
                                        }, null, -1)),
                                        _createElementVNode("div", _hoisted_19, [
                                            _createVNode(MGButton, {
                                                fullWidth: true,
                                                noCaps: true,
                                                text: `Connect with OPEN BANKING`,
                                                arrow: true,
                                                icon: require('@/assets/open-banking-bg.png'),
                                                onClick: handleLinkAccount
                                            }, null, 8, ["icon"])
                                        ]),
                                        _createVNode(MGButton, {
                                            fullWidth: true,
                                            noCaps: true,
                                            text: `Add an offline account`,
                                            stacked: true,
                                            arrow: true,
                                            alt2: true,
                                            icon: require('@/assets/offlineAccount.png'),
                                            onClick: handleLinkOfflineAccount
                                        }, null, 8, ["icon"]),
                                        _createVNode(MGButton, {
                                            fullWidth: true,
                                            noCaps: true,
                                            text: `Add a different account`,
                                            stacked: true,
                                            textOnly: true,
                                            icon: require('@/assets/arrow-left.png'),
                                            leftIconSize: 20,
                                            onClick: handleAddDifferentAccount
                                        }, null, 8, ["icon"])
                                    ]))
                        ])
                    ]),
                    _: 1
                }, 8, ["modelValue", "title", "height"])
            ], 64));
        };
    }
});
